module.exports = __webpack_public_path__ + "assets/img/icon1.696befa1.png";